import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import styled from 'styled-components'
import contactImage from '../images/main-images/Contact.svg'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import TextField from '../elements/TextField'
import AreaTextField from '../elements/AreaTextField'
import Button from '../components/Button.js'
import { size } from '../device'
import { Alert } from 'react-bootstrap'
import { motion } from "framer-motion"
import AppearDiv from '../elements/AppearDiv'
import CheckboxField from '../elements/CheckboxField'

/*
const RowFullView = styled(Row)`
    display: flex;
    align-items: center;
    height: calc(100vh - 160px);
    margin-bottom: 160px;
    @media ${device.tablet}{
        margin-bottom:80%;
    }
`;

const FirstCol = styled(Col)`
    order: 1;
    @media ${device.tablet}{
        order: 2;
        left:10%;
    }
    @media ${device.mobileL}{
        left: 10px;
    }
    @media ${device.mobileM}{
        left: 0px;
    }
    @media ${device.mobileS}{
        left: 0px;
    }
`

const AlertStyled = styled(Alert)`
    width:320px;
`

const SecondCol = styled(Col)`
    order: 2;
    
    @media ${device.tablet}{
        order: 1;
    }
`
*/

const CompanyInformationContainer = styled.div`
    @media (max-width: 575px) {
        width: 100%;
    }

    @media (min-width: 576px){
        width: 550px;
    }
`

const RowFullView = styled(Row)`
    display: flex;
    align-items: center;   
    margin-bottom: 160px;

    @media (min-width: ${size.tablet}){
        height: calc(100vh - 160px);
    }
`;

const FirstCol = styled(Col)`
    @media (max-width: 767px){
        order: 2;
        margin-top: 100px;
    }

    @media (min-width: ${size.tablet}){
        order: 1;
    }
`

const AlertStyled = styled(Alert)`
    @media (min-width: ${size.tablet}){
        width:320px;
    }
`

const SecondCol = styled(Col)`
    @media (max-width: 767px){
        order: 1;
    }

    @media (min-width: ${size.tablet}){
        order: 2;
    }
`

const FooterItemTitle = styled.p`
    font-weight: 500;
`;

const FooterText = styled.p`
    margin-bottom: 5px;
`;


const ContactMain = () => {


        
    return (
        <AppearDiv>
        <RowFullView>
        <FirstCol md={5}>
        <CompanyInformationContainer>
        <h2>Skontaktuj się z nami</h2>
        <br></br>
        <FooterText>{"Necuit.com"}</FooterText>
        <FooterText>{"66-008 Drzonów 20"}</FooterText>
        <FooterText>{"tel.: +48 537 661 799"}</FooterText>
        <FooterText>{"e-mail: info@necuit.com"}</FooterText>
        </CompanyInformationContainer>
        </FirstCol>
        </RowFullView>
        </AppearDiv>
    )
}

export default ContactMain
